// ./src/utils/analytics/pageView.ts
//
// When a route change is a PAGE VIEW (ROADMAP #62 P7). Only a different PATH is: `history.pushState` / `replaceState`
// also run for things that are not a new page — the wizard's exit guard pushes a same-URL sentinel on mount and on every
// intercepted Back, and filters rewrite the query string — and each of those used to be counted.
// ⚠ Pure, so `check-analytics` RUNS it.

export const isNewPageView = (previousPath: string | null, path: string): boolean => previousPath !== path;
